<template>
<div class="right-panel">
        <!-- 第一块：总体统计 -->
        <div class="right-section right-section-1 border-box">
          <OverallStats />
        </div>
        
        <!-- 第二块：疾病收入大盘 -->
        <div class="right-section right-section-2 border-box">
          <RightDiseaseRevenue />
        </div>
        
        <!-- 第三块：贴敷复诊率 -->
        <div class="right-section right-section-3 border-box">
          <RightRevisitRate />
        </div>
      </div>
</template>

<script>
import OverallStats from "./OverallStats.vue";
import RightDiseaseRevenue from "./RightDiseaseRevenue.vue";
import RightRevisitRate from "./RightRevisitRate.vue";

export default {
  name: 'RightPanel',
  components: {
    OverallStats,
    RightDiseaseRevenue,
    RightRevisitRate,
  },
  props: {
    kfxs: {
      type: Object,
      default: () => ({
        kf: 2917.95,
        xs: 21.03
      })
    }
  },
  data() {
    return {
      activeTab: 'all',
      timeTabs: [
        { label: '全部', value: 'all' },
        { label: '一年', value: 'year' },
        { label: '半年', value: 'half' }
      ]
    }
  },
  methods: {
    formatNumber(num) {
      return Number(num).toLocaleString()
    }
  }
}
</script>

<style lang="scss" scoped>
// 右侧面板 - 三个区域
.right-panel {
      width: 25%;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      gap: 10px;
      // .border-box {
      //   background: url("../../../assets/map/border-bg2.png") center center no-repeat;
      //   background-size: 100% 100%;
      // }
      .right-section {
        // border: 2px solid;
        // border-radius: 4px;
        padding: 10px;
        overflow: hidden;
        
        &.right-section-2 {
          flex: 1;
          min-height: 200px;
          // border-color: #fd79a8; // 粉红色 - 疾病收入
          // background-color: rgba(253, 121, 168, 0.1);
        }
        
        &.right-section-3 {
          flex: 1;
          min-height: 200px;
          // border-color: #fdcb6e; // 橙色 - 复诊率
          // background-color: rgba(253, 203, 110, 0.1);
        }
      }
    }
</style>





